var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFast(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 72,
    rx: 16,
    fill: "#FFF7DC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.4706 57H30.9505L33.4706 40.6667H24.6504C23.1887 40.6667 23.2139 39.92 23.6928 39.1267C24.1716 38.3333 23.8188 38.94 23.8692 38.8467C27.12 33.5267 32.0089 25.5933 38.5107 15H41.0307L38.5107 31.3333H47.3309C48.5657 31.3333 48.7421 32.1033 48.5153 32.5233L48.3389 32.8733C38.4099 48.95 33.4706 57 33.4706 57Z",
    fill: "#F5B11E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFast);
export default __webpack_public_path__ + "static/media/fast.666138126daee363a8485324e464bcbb.svg";
export { ForwardRef as ReactComponent };